import { createContext, ReactNode, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

interface SearchContextType {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  performSearch: () => void;
  isSearching: boolean;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export const SearchProvider = ({ children }: { children: ReactNode }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const navigate = useNavigate();

  const performSearch = () => {
    if (!searchTerm.trim()) {
      return;
    }

    setIsSearching(true);
    // Navigate to the explorer page with search term in URL
    navigate(`/explore?search=${encodeURIComponent(searchTerm.trim())}`);
    setIsSearching(false);
  };

  return (
    <SearchContext.Provider value={{
      searchTerm,
      setSearchTerm,
      performSearch,
      isSearching
    }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = (): SearchContextType => {
  const context = useContext(SearchContext);
  if (context === undefined) {
    throw new Error("useSearch must be used within a SearchProvider");
  }
  return context;
};
